import * as CONS from '../../constants/urls'
import http from './httpService'

const API_ENDPOINT = `${CONS.API_ENDPOINT_EBM}/Compra`

export function crearPedido(compra) {
  return http.post(`${API_ENDPOINT}/CrearPedido/`, compra)
}
export function crearPedidoItem(compraItem) {
  return http.post(`${API_ENDPOINT}/CrearPedidoItem/`, compraItem)
}
export function obtenerPublicacion(idUsuario, idPublicacion) {
  return http.get(`${API_ENDPOINT}/ObtenerPublicacion/${idUsuario}/${idPublicacion}`)
}
export function obtenerPresupuestoItems(idUsuario, idPresupuesto) {
  return http.get(`${API_ENDPOINT}/ObtenerPresupuestoItems/${idUsuario}/${idPresupuesto}`)
}
